import { inject as A, onBeforeMount as R, computed as x } from "vue";
import { useSsrAdapter as B } from "./ghl-ui.es648.js";
import D from "./ghl-ui.es1360.js";
import { configProviderInjectionKey as K } from "./ghl-ui.es921.js";
import { cssrAnchorMetaName as v } from "./ghl-ui.es1270.js";
import m from "./ghl-ui.es922.js";
function G(n) {
  return n;
}
function _(n, t, d, i, p, s) {
  const l = B(), e = A(K, null);
  if (d) {
    const o = () => {
      const r = s == null ? void 0 : s.value;
      d.mount({
        id: r === void 0 ? t : r + t,
        head: !0,
        props: {
          bPrefix: r ? `.${r}-` : void 0
        },
        anchorMetaName: v,
        ssr: l
      }), e != null && e.preflightStyleDisabled || D.mount({
        id: "n-global",
        head: !0,
        anchorMetaName: v,
        ssr: l
      });
    };
    l ? o() : R(o);
  }
  return x(() => {
    var o;
    const { theme: { common: r, self: g, peers: b = {} } = {}, themeOverrides: f = {}, builtinThemeOverrides: c = {} } = p, { common: O, peers: h } = f, { common: S = void 0, [n]: { common: C = void 0, self: T = void 0, peers: j = {} } = {} } = (e == null ? void 0 : e.mergedThemeRef.value) || {}, { common: M = void 0, [n]: u = {} } = (e == null ? void 0 : e.mergedThemeOverridesRef.value) || {}, { common: N, peers: P = {} } = u, a = m({}, r || C || S || i.common, M, N, O), y = m(
      // {}, executed every time, no need for empty obj
      (o = g || T || i.self) === null || o === void 0 ? void 0 : o(a),
      c,
      u,
      f
    );
    return {
      common: a,
      self: y,
      peers: m({}, i.peers, j, b),
      peerOverrides: m({}, c.peers, P, h)
    };
  });
}
_.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
export {
  G as createTheme,
  _ as default
};
